import { CircularProgress } from '@mui/material'
import React from 'react'

const OrangeButton = ({
  text,
  py = 'py-2.5',
  px = 'px-3',
  textSize = 'text-sm',
  fontWeight = 'font-semibold',
  onClick,
  loading = false,
  etcClass = '',
  className = '',
  ...props
}) => {
  return (
    <button
      className={`!bg-primary-button hover:!bg-primary-button-hover hover:border-primary-button-hover transition-colors duration-200 ease rounded-lg ${py} ${px} text-white ${textSize} ${fontWeight} ${etcClass} border-[1px] border-primary-button ${className}`}
      onClick={onClick}
      {...props}
    >
      {loading ? <CircularProgress color="#f79009 " size={20} /> : text}
    </button>
  )
}

export default OrangeButton
